module.exports = __webpack_public_path__ + "img/information-bg-mobile.d06eb73a.jpg";